import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { useLocation, useNavigate } from "react-router-dom";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import TkStepper from "../../components/atoms/TkStepper";
import { Box } from "@mui/material";
import TkTable from "../../components/atoms/TkTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkButton from "../../components/atoms/TkButton";
import { funBodyList } from "./hooks/useHooks";
import { headList, stepperData } from "../SCRC060110/parts";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { httpAPI_STA014, httpAPI_STA018, httpAPI_STA023 } from "./api/request";
import { IAPI_STA023_Request } from "../../type/apiType";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { Status } from "../../assets/data/Constants";
import { TkRouteContext } from "../../context/tkRouteContext";
import { CheckedList } from "../../type/apiType/IAPI_STA023";

/**
 * SCRC060110コンポーネント。
 * @returns JSX.Element
 */
const SCRC060110 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { state: businessState, setState: setBusinessStete } =
    useContext(BusinessContext);
  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const [bodyList, setBodyList] = useState<any>([]);
  const { state, setState } = useContext(GlobalContext);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [issubmitOpen, setIssubmitOpen] = useState(false);
  const [facilityNameList, setFacilityNameList] = useState<any>([]);
  const [staffNo, setStaffNo] = useState("");
  const [activeStep, setActiveStep] = useState(1);
  const [isBtnVisible, setIsBtnVisible] = useState(true);
  const [apiRes, setApiRes] = useState<any>({});
  const [checkedList, setCheckedList] = useState<CheckedList[]>([]);
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const isDaiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.DAIKOSHA;
  const applyId =
    location.state?.applyId ??
    businessState.job_23?.applyId ??
    businessState.job_30?.applyId;

  // 修正ボタン
  const handleUpdate = (staffNo: any, facilityNo: any) => {
    setBusinessStete({
      ...businessState,
      job_23: {
        ...businessState.job_23,
        staffNo: staffNo,
        facilityName: undefined,
        facilityNo: undefined,
        registrationProcedureInfo: {},
      },
    });

    navigate("/SCRC060108", { state: { facilityNo: facilityNo } });
  };

  const handleDelete = (staffNo: any) => {
    setStaffNo(staffNo);
    setDeleteOpen(true);
  };

  const handleSuccessDelete = async () => {
    // 職員情報削除API 呼び出し
    try {
      const res = await httpAPI_STA014({
        staffNo: staffNo,
        applyId: applyId,
        contractorNo: isKiko
          ? businessState.common?.contractorNo
          : state.authInfo?.contractorNo,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setDeleteOpen(false);
        handleInit();
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 初期化
  const handleInit = async () => {
    // 加入登録手続き一覧参照API 呼び出し
    try {
      const res = await httpAPI_STA018({
        applyId: applyId,
      });

      if (res.resultCd === "I0000") {
        // レスポンスの値からコンポーネント形に変更
        let bodyList = funBodyList(
          res.facilityList!,
          handleUpdate,
          handleDelete
        );

        if (
          !(
            res.latestApplyStatus === Status["届出待ち"] ||
            res.latestApplyStatus === Status["差戻し一時保存"]
          )
        ) {
          bodyList = funBodyList(
            res.facilityList!,
            handleUpdate,
            handleDelete,
            true
          );
          setActiveStep(3);
          setIsBtnVisible(false);
        }
        setBusinessStete({
          ...businessState,
          job_23: {
            ...businessState.job_23,
            staffNo: "",
          },
        });
        let names = res.facilityList?.map((item) => {
          return {
            name: item.facilityName,
            num: item.staffList?.length,
          };
        });

        setFacilityNameList(names);

        setBodyList(bodyList);
        setApiRes(res);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  //  機構へ提出、申請
  const handleSubmitChange = async (date?: any) => {
    let subMitData: IAPI_STA023_Request = {
      applyId: applyId,
      contractorNo: isKiko
        ? businessState.common?.contractorNo!
        : state.authInfo?.contractorNo!,
      receptionDate: date,
      screenId: "SCRC060110",
      checkedList: checkedList,
    };
    try {
      const res = await httpAPI_STA023({
        ...subMitData,
      });

      if (res.resultCd === "I0000") {
        setCheckedList([]);
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        if (res.resultCd === "TKMSG_SVR0007W") {
          setCheckedList(res.checkedList || []);
        }
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
    setIssubmitOpen(false);
  };

  // 職員登録
  const staffRegistration = () => {
    if (isDaiko) {
      navigate("/SCRC060108");
    } else {
      setBusinessStete({
        ...businessState,
        job_23: {
          ...businessState.job_23,
          facilityName: undefined,
          facilityNo: undefined,
          registrationProcedureInfo: {},
        },
      });
      navigate("/SCRC060108", { state: { signUpFlg: true } });
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(
    () => {
      if (location.state?.deleteFlg) {
        if (routerState) {
          if (
            !routerState.routerList?.find(
              (item) =>
                item.href === "/SCRC060108" || item.href === "/SCRC060009"
            )
          ) {
            return;
          }

          const updatedRouterState = routerState.routerList?.filter(
            (item) => item.href !== "/SCRC060108" && item.href !== "/SCRC060009"
          );
          if (
            !routerState.routerList?.find((item) => item.href === "/SCRC060110")
          ) {
            updatedRouterState?.push({
              href: "/SCRC060110",
              title: "加入登録手続き",
            });
          }
          setRouterState({
            ...routerState,
            routerList: updatedRouterState,
          });
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [routerState]
  );

  return (
    <Box className="SCRC060110" data-testid="SCRC060110PageForTest">
      <TkStepper steps={stepperData} activeStep={activeStep} />

      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC060110_01}</TkInfoManual>
      {isKiko && (
        <TkContractorAndNumberLine
          name={"契約者（法人）名"}
          no={
            businessState.common?.contractorNo +
            ":" +
            businessState.common?.contractorName
          }
        />
      )}
      <Box className="info">
        {facilityNameList.map((item: any, index: any) => {
          return (
            <Box key={index}>
              {item.name}登録人数:{item.num}人
            </Box>
          );
        })}
        <Box className="staffRegistration">
          <TkButton
            onClick={staffRegistration}
            disabled={
              apiRes.latestApplyStatus !== Status["届出待ち"] &&
              apiRes.latestApplyStatus !== Status["差戻し一時保存"]
            }
          >
            職員登録
          </TkButton>
        </Box>
        <TkTable headList={headList} bodyList={bodyList}></TkTable>
      </Box>
      <Box className="butt">
        <TkBackButton useBackParam navigateParam={{ signUpFlg: true }} />
        {isBtnVisible && (
          <TkButton
            data-testid="submitButton"
            onClick={() => setIssubmitOpen(true)}
            disabled={apiRes?.facilityList?.length === 0}
          >
            {isKiko ? "申請" : "機構へ提出する"}
          </TkButton>
        )}
      </Box>

      <TkMessageDialog
        open={deleteOpen}
        onOky={handleSuccessDelete}
        onCancel={() => setDeleteOpen(false)}
        title="確認（職員情報を削除します）"
        contextText="　職員情報の削除を行いますが、問題ないでしょうか。"
        cancelText="いいえ"
        okText="はい"
      />

      {isKiko ? (
        <TkDateDialog
          open={issubmitOpen}
          onOky={handleSubmitChange}
          onCancel={() => setIssubmitOpen(false)}
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          title="確認（申請）"
          contextText={"　申請を行いますが、問題ないでしょうか。"}
          cancelText="いいえ"
          okText="はい"
        />
      ) : (
        <TkMessageDialog
          open={issubmitOpen}
          onOky={handleSubmitChange}
          onCancel={() => setIssubmitOpen(false)}
          title="確認（機構へ提出する）"
          contextText="　機構へ提出を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      )}
    </Box>
  );
};

export default SCRC060110;
